// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Opof1","footer":"styles_footer__1xGxI"};